import React from "react";
import Select from "react-select";
import { InputContainer } from "styles/components/AnimatedInput";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "5px",
    borderColor: "#87cdf1",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "1rem",
    display: "none"
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "36px",
    overflow: "inherit",
  }),
  Input: (provided) => ({
    ...provided,
    height: "unset",
  }),
  menu: (provided) => ({
    ...provided,
    position: "absolute",
    textAlign: "left",
    zIndex: "2",
  }),
};

const DropDown = (props) => {
  return (
    <InputContainer className={props.className}>
      <div className="input-container">
        <Select
          className={"react-select-container"}
          name={props?.name}
          value={props?.data.filter((option) => option.value === props?.searchDropDown)}
          options={props?.data}
          isDisabled={props?.disabled}
          classNamePrefix="react-select"
          // placeholder={props?.placeholder}
          isSearchable={props?.searchable}
          styles={customStyles}
          maxMenuHeight={150}
          onInputChange={inputValue =>
            (inputValue.length <= 18 ? inputValue : '')
          }
          onChange={(data) => {
            props?.onChangeHandler && props?.onChangeHandler(data.value, data);
          }}
        />

        <label className={"filled"} htmlFor={props?.name}>
          {props?.placeholder}
        </label>
      </div>
    </InputContainer>
  );
};
export default DropDown;
